import { view } from '@yola/ws-sdk';
import { LINE_HEIGHT_CLASS_NAME } from '../constants/responsive-class-names';
import constants from '../constants';

const { LINE_HEIGHT_UNIT } = constants.common;

const changeLineHeight = ({ value, focusedElements, breakpoint }) => {
  focusedElements.forEach((node) => {
    const currentClass = node.getAttribute('class') || '';

    const newClass =
      value === null
        ? view.helpers.removeResponsiveClasses({
            currentClass,
            className: LINE_HEIGHT_CLASS_NAME,
            breakpoint,
          })
        : view.helpers.getPatchedResponsiveClass({
            currentClass,
            className: LINE_HEIGHT_CLASS_NAME,
            value: `${value}${LINE_HEIGHT_UNIT}`,
            breakpoint,
          });

    node.setAttribute('class', newClass.trim());
  });
};

export default changeLineHeight;
